import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { FC } from "react";

import { ClientErrorBoundary } from "../../components/ClientErrorBoundary";
import Wrapper from "../../components/SliceWrapper";
import { Testimonials2 as Testimonials2Impl } from "../../components/Testimonials2";

/**
 * Props for `Testimonials2`.
 */
export type Testimonials2Props =
  SliceComponentProps<Content.Testimonials2Slice>;

/**
 * Component for "Testimonials2" Slices.
 */
const Testimonials2: FC<Testimonials2Props> = ({ slice }) => {
  const { heading, layout, testimonials } = slice.primary;

  if (!testimonials.length) {
    return null;
  }

  return (
    <ClientErrorBoundary message="Testimonials2 slice error boundary">
      {/* @ts-expect-error — SliceWrapper is an untyped JS component */}
      <Wrapper data-analytics-component="testimonials2" slice={slice}>
        <Testimonials2Impl
          heading={heading}
          items={testimonials}
          layout={layout}
        />
      </Wrapper>
    </ClientErrorBoundary>
  );
};

export default Testimonials2;
